<template>
	<div class="main-container">
		<div class="material-library-page">
			<div class="management-header">
				<div>
					<h1 class="page-title">教材库管理</h1>
					<p class="page-subtitle">管理系统默认教材，支持上传、分类和共享教材资源</p>
				</div>
				<div class="management-actions">
					<!-- <button class="btn btn-secondary" @click="showFilter = !showFilter">
							🔍 筛选
						</button> -->
					<button class="btn btn-primary" @click="showUploadModal">
						📤 上传教材
					</button>
				</div>
			</div>

			<!-- Filter Section -->
			<div v-if="showFilter" class="filter-section">
				<div class="filter-row">
					<div class="filter-group">
						<label class="filter-label">课程分类</label>
						<el-select class="form-el-select" v-model="levelId" @change="categoriesChange">
							<el-option :value="item.id" v-for="item in categories" :key="item.id"
								:label="item.fileName">{{item.fileName}}</el-option>
						</el-select>
					</div>
					<!-- <div class="filter-group">
							<label class="filter-label">文件格式</label>
							<select class="filter-select" v-model="filters.format" @change="applyFilters">
								<option value="">全部格式</option>
								<option value="PDF">PDF</option>
								<option value="DOC">Word</option>
								<option value="PPT">PowerPoint</option>
							</select>
						</div>
						<div class="filter-group">
							<label class="filter-label">教材类型</label>
							<select class="filter-select" v-model="filters.type" @change="applyFilters">
								<option value="">全部类型</option>
								<option value="default">默认教材</option>
								<option value="custom">用户上传</option>
								<option value="shared">共享教材</option>
							</select>
						</div>
						<div class="filter-group">
							<input type="text" class="filter-input" v-model="filters.search" @input="applyFilters"
								placeholder="搜索教材名称...">
						</div> -->
				</div>
			</div>


			<!-- Material Grid -->
			<div class="category-section">
				<div class="category-header">
					<div class="category-title">
						📚 所有教材
						<!-- <span class="category-count">{{ filteredMaterials.length }}</span> -->
					</div>
				</div>

				<!-- Grid View -->
				<div class="material-grid">
					<div v-for="(material,index) in list" :key="material.id" class="material-item">
						<div class="material-header">
							<div class="material-icon">
								📄
							</div>
							<div class="material-info">
								<div class="material-name">{{ material.fileName }}</div>
								<div class="material-meta">
									<span>{{ material.fileName.split('.').pop() }}</span>
									<span>{{ formatFileSize(material.fileSize) }}</span>
									<span>{{ material.uploadTime.slice(0, 10) }}</span>
								</div>
							</div>
						</div>
						<div class="material-desc">{{ material.content }}</div>
						<!-- <div class="material-tags">
								<span class="tag course">{{ material.courseName }}</span>
								<span v-for="tag in material.tags" :key="tag" class="tag">
									{{ tag }}
								</span>
								<span v-if="material.isDefault" class="tag default">
									默认教材
								</span>
								<span v-if="material.isShared" class="tag shared">
									已共享
								</span>
							</div> -->
						<div class="material-actions">
							<button class="action-button primary" @click="downloadFile(material)">
								<span>📥</span>
								下载
							</button>
							<button class="action-button secondary" @click="previewMaterial(material,false)">
								<span>👁️</span>
								预览
							</button>
							<!-- <button class="action-button secondary" @click="editMaterial(material)">
									<span>✏️</span>
									编辑
								</button> -->
							<button class="action-button danger" @click="deleteMaterial(material.id,index)">
								<span>🗑️</span>
								删除
							</button>
						</div>
					</div>
				</div>

				<!-- Empty State -->
				<div v-if="list.length === 0" class="empty-state">
					<div class="empty-icon">📚</div>
					<div class="empty-title">还没有上传任何教材</div>
					<button class="btn btn-primary" @click="showUploadModal">
						📤 上传第一个教材
					</button>
				</div>
			</div>

			<!-- Upload Modal -->
			<div class="modal-overlay" :class="{ show: showModal }" @click="closeModal">
				<div class="modal" @click.stop>
					<div class="modal-header">
						<h2 class="modal-title">{{ isEditing ? '编辑教材' : '上传教材' }}</h2>
						<p class="modal-subtitle">上传教材文件并设置相关信息</p>
					</div>
					<div class="modal-body">
						<form @submit.prevent="saveMaterial">
							<div class="form-group" v-if="!isEditing">
								<label class="form-label">教材文件</label>
								<div class="upload-area" @click="triggerFileInput" @dragover.prevent
									@drop.prevent="handleDrop">
									<div class="upload-icon">📄</div>
									<div class="upload-text">点击上传或拖拽教材文件</div>
									<div class="upload-hint">支持 PDF、WORD、PPT格式，单个文件不超过 50MB</div>
									<button type="button" class="btn btn-primary">选择文件</button>
								</div>
								<input ref="fileInput" type="file" style="display: none;"
									accept=".pdf,.docx,.doc,.ppt,.pptx" @change="handleFileSelect">
								<div v-if="materialForm.file" class="selected-file">
									<span class="file-icon">{{ getFileIcon(materialForm.file.name) }}</span>
									<span class="file-name">{{ materialForm.file.name }}</span>
									<span class="file-size">({{ formatFileSize(materialForm.file.size) }})</span>
								</div>
							</div>
							<div class="form-group">
								<label class="form-label">教材名称</label>
								<input type="text" class="form-input" v-model="materialForm.fileName"
									placeholder="请输入教材名称" required>
							</div>
							<div class="form-group">
								<label class="form-label">适用课程</label>
								<el-select class="form-el-select" v-model="materialForm.parentId">
									<el-option :value="item.id" v-for="item in categoryList" :key="item.id"
										:label="item.fileName+'('+item.category+')'">{{item.fileName+'('+item.category+')'}}</el-option>
								</el-select>
							</div>
							<div class="form-group">
								<label class="form-label">教材描述</label>
								<textarea class="form-textarea" v-model="materialForm.content"
									placeholder="请简要描述教材内容"></textarea>
							</div>
							<!-- <div class="checkbox-group">
									<div class="checkbox-item">
										<input type="checkbox" id="setAsDefault" v-model="materialForm.isDefault">
										<label for="setAsDefault" class="checkbox-label">设为系统默认教材</label>
									</div>
									<div class="checkbox-item">
										<input type="checkbox" id="allowShare" v-model="materialForm.isShared">
										<label for="allowShare" class="checkbox-label">允许其他用户使用</label>
									</div>
								</div> -->
						</form>
					</div>
					<div class="modal-footer">
						<button class="btn btn-secondary" @click="closeModal">取消</button>
						<button class="btn btn-primary" @click="saveMaterial"
							:disabled="btnDisabled">{{ isEditing ? '保存' : '上传' }}教材</button>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import domain from '../../config/app.js'
	import {
		mapGetters
	} from 'vuex'
	export default {
		name: 'MaterialLibraryPage',
		components: {},
		data() {
			return {
				levelId: '', //课程分类ID
				categories: [], //课程分类
				list: [], //数据
				categoryList: [], //适用课程
				showFilter: true,
				showModal: false,
				isEditing: false,
				editingMaterial: null,
				materialForm: {
					file: null,
					fileName: '',
					parentId: '',
					content: '',
					isDefault: false,
					isShared: true
				},
				btnDisabled: false,
			}
		},
		computed: {
			hasFilters() {
				return this.filters.category || this.filters.format || this.filters.type || this.filters.search
			},
			...mapGetters([
				'currentUser'
			]),
		},
		mounted() {
			this.fetchAllFiles();
		},
		methods: {
			async fetchAllFiles() {
				try {
					// 1. 获取所有分类
					const categoryResponse = await this.HttpUtils.get('/api/system/gjfilecategory/level1', {});
					this.categories = categoryResponse.data.data || categoryResponse;
					this.levelId = this.categories[0].id;
					this.subcategory()
				} catch (error) {
					console.error("获取数据失败：", error);
				}
			},

			async subcategory() { //根据类别查询教材库文件
				try {
					const fileResponse = await this.HttpUtils.get(
						`/api/system/gjfilecategory/subcategory/${this.levelId}`, {});
					const categories = fileResponse.data.data || fileResponse;
					this.categoryList = categories;

					// 2. 遍历分类，获取每个分类的文件数据
					const filePromises = categories.map(async (category) => {
						const fileResponse = await this.HttpUtils.get(
							`/api/system/gjfilecategory/subcategory/files/${category.id}`, {});
						const files = fileResponse.data.data || fileResponse;
						return files; // 返回当前分类的文件数组
					});

					// 3. 等待所有文件请求完成
					const allFilesByCategory = await Promise.all(filePromises);

					// 4. 使用 flatMap 合并所有文件数据到一个数组
					this.list = allFilesByCategory.flat();
					console.log("合并后的所有文件数据：", this.list);
				} catch (error) {
					console.error("获取数据失败：", error);
				}
			},
			categoriesChange(val) {
				this.levelId = val;
				this.subcategory()
			},

			showUploadModal() {
				this.resetForm()
				this.showModal = true;
				this.btnDisabled = false;
			},
			editMaterial(material) {
				this.isEditing = true
				this.editingMaterial = material
				this.materialForm = {
					file: null,
					fileName: material.fileName,
					parentId: material.parentId,
					content: material.content,
					isDefault: material.isDefault,
					isShared: material.isShared
				}
				this.showModal = true
			},
			deleteMaterial(id, index) {
				this.$confirm('确定要删除这个教材吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.HttpUtils.delete('/api/system/gjfilecategory/file/' + id, {}).then(res => {
						console.log(res)
						if (res.data.code === 200) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.list.splice(index, 1);
							//this.courseClassification()
						} else {
							this.$message.error(res.data.msg)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			async downloadFile(file) {
				try {
					// 显示加载状态
					//this.loading = true;

					// 获取文件流
					const response = await fetch(domain.urls + '/api/profile/' + file.filePath, {
						method: 'GET',
						headers: {
							'Content-Type': 'application/octet-stream',
						},
					});

					if (!response.ok) {
						throw new Error('下载失败');
					}

					// 转换为blob
					const blob = await response.blob();

					// 创建下载链接
					const downloadUrl = window.URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = downloadUrl;
					link.download = file.originalName || 'download';

					// 触发下载
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

					// 清理内存
					window.URL.revokeObjectURL(downloadUrl);

					this.$message.success('下载成功');

				} catch (error) {
					console.error('下载失败:', error);
					this.$message.error('下载失败');
				} finally {
					//this.loading = false;
				}
			},
			// 文件操作
			previewMaterial(item, isEdit) {
				var type = ''
				if (item.fileName && item.fileName.includes('.')) {
					type = item.fileName.split('.').pop();
				} else {
					type = '';
				}
				console.log(type)
				const route = this.$router.resolve({
					path: '/view-online',
					query: {
						url: item.filePath,
						type: type,
						isEdit: isEdit,
						name: item.fileName
					}
				});

				window.open(route.href, '_blank');
				// this.$router.push({
				// 	path: '/view-online?url=' + item.filePath + '&type=' + type + '&isEdit=' +
				// 		isEdit + '&name=' + item.originalName
				// });
			},
			saveMaterial() {
				if (!this.materialForm.fileName || !this.materialForm.parentId || !this.materialForm.content) {
					this.$message({
						message: '请填写完整的教材信息',
						type: 'warning'
					});
					return
				}

				if (!this.isEditing && !this.materialForm.file) {
					this.$message({
						message: '请选择要上传的教材文件',
						type: 'warning'
					});
					return
				}
				this.btnDisabled = true;

				if (this.isEditing) {
					const updatedMaterial = {
						...this.editingMaterial,
						name: this.materialForm.name,
						courseId: this.materialForm.courseId,
						courseName: courseInfo.name,
						desc: this.materialForm.desc,
						isDefault: this.materialForm.isDefault,
						isShared: this.materialForm.isShared
					}
					this.$emit('material-updated', updatedMaterial)
				} else {
					const formData = new FormData();
					formData.append('file', this.materialForm.file);
					formData.append('parentId', this.materialForm.parentId);
					formData.append('userId', this.currentUser.userId);
					// 发送上传请求
					this.HttpUtils.post('/api/gjfiles/upload', formData, {
						//'Content-Type': 'multipart/form-data'
					}).then(result => {
						this.materialForm = {
							fileName: this.materialForm.fileName,
							originalName: result.data.data.originalName,
							filePath: result.data.data.filePath,
							content: this.materialForm.content,
							fileType: result.data.data.fileType,
							mimeType: result.data.data.mimeType,
							fileSize: result.data.data.fileSize,
							parentId: result.data.data.parentId,
							category: result.data.data.category,
							fileKey: result.data.data.fileKey,
							categoryType: result.data.data.categoryType,
							unitFlg: result.data.data.unitFlg,
							userId: this.currentUser.userId,
						};
						if (result.data.data) {
							this.uploadTextbooks()
						}
					}).catch(error => {});
				}
			},
			uploadTextbooks() { //上传教材
				this.HttpUtils.post('/api/system/gjfilecategory/file', this.materialForm).then(res => {
					console.log(res)
					if (res.data.code === 200) {
						this.btnDisabled = false;
						this.$message({
							message: '上传成功',
							type: 'success'
						});
						this.subcategory()
						this.closeModal()
					} else {
						this.btnDisabled = false;
						this.$message.error(res.data.msg)
					}
				})
			},
			closeModal() {
				this.showModal = false
				this.resetForm()
			},
			resetForm() {
				this.isEditing = false
				this.editingMaterial = null
				this.materialForm = {
					file: null,
					fileName: '',
					parentId: '',
					content: '',
					isDefault: false,
					isShared: true
				}
			},
			triggerFileInput() {
				this.$refs.fileInput.click()
			},
			handleFileSelect(event) {
				const file = event.target.files[0]
				if (file && this.validateFile(file)) {
					this.materialForm.file = file
					if (!this.materialForm.name) {
						this.materialForm.name = file.name.replace(/\.[^/.]+$/, '')
					}
				}
			},
			handleDrop(event) {
				const file = event.dataTransfer.files[0]
				if (file && this.validateFile(file)) {
					this.materialForm.file = file
					if (!this.materialForm.name) {
						this.materialForm.name = file.name.replace(/\.[^/.]+$/, '')
					}
				}
			},
			validateFile(file) {
				const allowedTypes = [
					'application/pdf',
					'application/msword', // .doc
					'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
					'application/vnd.ms-powerpoint', // .ppt
					'application/vnd.openxmlformats-officedocument.presentationml.presentation' // .pptx
				]

				if (!allowedTypes.includes(file.type)) {
					this.$message({
						message: '不支持的文件格式，请上传 PDF、WORD、PPT 文件',
						type: 'warning'
					});
					return false
				}

				if (file.size > 50 * 1024 * 1024) {
					this.$message({
						message: '文件大小不能超过 50MB',
						type: 'warning'
					});
					return false
				}

				return true
			},
			getFileIcon(format) {
				switch (format?.toUpperCase()) {
					case 'PDF':
						return '📄'
					case 'DOC':
					case 'DOCX':
						return '📝'
					case 'PPT':
					case 'PPTX':
						return '📊'
					default:
						return '📄'
				}
			},
			formatFileSize(bytes) {
				if (bytes === 0) return '0 Bytes'
				const k = 1024
				const sizes = ['Bytes', 'KB', 'MB', 'GB']
				const i = Math.floor(Math.log(bytes) / Math.log(k))
				return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
			},
		}
	}
</script>

<style scoped>
	.material-library-page .management-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 32px;
	}

	@media (max-width: 768px) {
		.material-library-page .management-header {
			flex-direction: column;
			align-items: flex-start;
			gap: 16px;
		}
	}

	.material-library-page .page-title {
		font-size: 32px;
		font-weight: 800;
		color: #111827;
		margin-bottom: 8px;
	}

	.material-library-page .page-subtitle {
		font-size: 16px;
		color: #6B7280;
	}

	.material-library-page .management-actions {
		display: flex;
		gap: 12px;
	}

	/* Filter Section */
	.material-library-page .filter-section {
		background: white;
		border-radius: 16px;
		padding: 20px;
		margin-bottom: 24px;
		box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
	}

	.material-library-page .filter-row {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
		gap: 16px;
	}

	.material-library-page .filter-group {
		display: flex;
		flex-direction: column;
	}

	.material-library-page .filter-label {
		font-size: 14px;
		font-weight: 600;
		margin-bottom: 6px;
		color: #111827;
	}

	.material-library-page .filter-select,
	.material-library-page .filter-input {
		padding: 8px 12px;
		border: 1px solid #D1D5DB;
		border-radius: 8px;
		font-size: 14px;
		transition: all 0.3s ease;
	}

	.material-library-page .filter-select:focus,
	.material-library-page .filter-input:focus {
		outline: none;
		border-color: #2E5CE6;
		box-shadow: 0 0 0 3px rgba(46, 92, 230, 0.1);
	}

	/* Statistics Section */
	.material-library-page .stats-section {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
		gap: 16px;
		margin-bottom: 24px;
	}

	.material-library-page .stat-card {
		background: white;
		border-radius: 12px;
		padding: 20px;
		box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
		display: flex;
		align-items: center;
		gap: 16px;
	}

	.material-library-page .stat-icon {
		font-size: 32px;
		opacity: 0.8;
	}

	.material-library-page .stat-content {
		flex: 1;
	}

	.material-library-page .stat-number {
		font-size: 24px;
		font-weight: 800;
		color: #111827;
		line-height: 1;
		margin-bottom: 4px;
	}

	.material-library-page .stat-label {
		font-size: 14px;
		color: #6B7280;
	}

	/* Category Section */
	.material-library-page .category-section {
		background: white;
		border-radius: 24px;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
		padding: 24px;
		border: 1px solid #E5E7EB;
	}

	.material-library-page .category-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
	}

	.material-library-page .category-title {
		font-size: 20px;
		font-weight: 700;
		color: #111827;
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.material-library-page .category-count {
		background: #E5E7EB;
		color: #6B7280;
		padding: 4px 12px;
		border-radius: 100px;
		font-size: 12px;
		font-weight: 600;
	}

	.material-library-page .view-toggle {
		display: flex;
		background: #F3F4F6;
		border-radius: 8px;
		padding: 2px;
	}

	.material-library-page .view-btn {
		padding: 6px 12px;
		border: none;
		background: none;
		border-radius: 6px;
		font-size: 12px;
		font-weight: 600;
		cursor: pointer;
		transition: all 0.2s ease;
		color: #6B7280;
	}

	.material-library-page .view-btn.active {
		background: white;
		color: #2E5CE6;
		box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
	}

	.material-library-page .view-btn:hover:not(.active) {
		color: #111827;
	}

	/* Grid View */
	.material-library-page .material-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
		gap: 16px;
	}

	@media (max-width: 768px) {
		.material-library-page .material-grid {
			grid-template-columns: 1fr;
		}
	}

	.material-library-page .material-item {
		background: white;
		border: 1px solid #E5E7EB;
		border-radius: 16px;
		padding: 20px;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.material-library-page .material-item:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
		border-color: #60A5FA;
	}

	.material-library-page .material-header {
		display: flex;
		align-items: center;
		gap: 12px;
		margin-bottom: 12px;
	}

	.material-library-page .material-icon {
		width: 40px;
		height: 40px;
		background: #F3F4F6;
		border-radius: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 20px;
	}

	.material-library-page .material-info {
		flex: 1;
	}

	.material-library-page .material-name {
		font-size: 16px;
		font-weight: 600;
		color: #111827;
		margin-bottom: 4px;
		line-height: 1.3;
	}

	.material-library-page .material-meta {
		font-size: 12px;
		color: #6B7280;
		display: flex;
		gap: 12px;
	}

	.material-library-page .material-desc {
		font-size: 14px;
		color: #6B7280;
		line-height: 1.4;
		margin-bottom: 16px;
	}

	.material-library-page .material-tags {
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
		margin-bottom: 16px;
	}

	.material-library-page .tag {
		background: #F3F4F6;
		color: #6B7280;
		padding: 4px 8px;
		border-radius: 12px;
		font-size: 12px;
		font-weight: 500;
	}

	.material-library-page .tag.course {
		background: rgba(46, 92, 230, 0.1);
		color: #2E5CE6;
	}

	.material-library-page .tag.default {
		background: rgba(16, 185, 129, 0.1);
		color: #10B981;
	}

	.material-library-page .tag.shared {
		background: rgba(245, 158, 11, 0.1);
		color: #F59E0B;
	}

	.material-library-page .material-actions {
		display: flex;
		gap: 8px;
	}

	.material-library-page .action-button {
		padding: 6px 12px;
		border: none;
		border-radius: 8px;
		font-size: 12px;
		font-weight: 600;
		cursor: pointer;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		display: flex;
		align-items: center;
		gap: 4px;
	}

	.material-library-page .action-button.primary {
		background: #2E5CE6;
		color: white;
	}

	.material-library-page .action-button.primary:hover {
		background: #1E3A8A;
	}

	.material-library-page .action-button.secondary {
		background: #F3F4F6;
		color: #111827;
	}

	.material-library-page .action-button.secondary:hover {
		background: #E5E7EB;
	}

	.material-library-page .action-button.danger {
		background: #EF4444;
		color: white;
	}

	.material-library-page .action-button.danger:hover {
		background: #DC2626;
	}

	/* List View */
	.material-library-page .material-list {
		background: #F9FAFB;
		border-radius: 12px;
		overflow: hidden;
	}

	.material-library-page .list-header {
		display: grid;
		grid-template-columns: 2fr 1.5fr 0.8fr 0.8fr 1fr 1.2fr;
		gap: 16px;
		padding: 16px 20px;
		background: #F3F4F6;
		font-size: 14px;
		font-weight: 600;
		color: #6B7280;
		border-bottom: 1px solid #E5E7EB;
	}

	@media (max-width: 768px) {
		.material-library-page .list-header {
			grid-template-columns: 2fr 1fr 1fr;
		}

		.material-library-page .list-header .course,
		.material-library-page .list-header .format,
		.material-library-page .list-header .date {
			display: none;
		}
	}

	.material-library-page .list-item {
		display: grid;
		grid-template-columns: 2fr 1.5fr 0.8fr 0.8fr 1fr 1.2fr;
		gap: 16px;
		padding: 16px 20px;
		border-bottom: 1px solid #E5E7EB;
		background: white;
		transition: all 0.2s ease;
	}

	.material-library-page .list-item:hover {
		background: #F9FAFB;
	}

	.material-library-page .list-item:last-child {
		border-bottom: none;
	}

	@media (max-width: 768px) {
		.material-library-page .list-item {
			grid-template-columns: 2fr 1fr 1fr;
		}

		.material-library-page .list-item .course,
		.material-library-page .list-item .format,
		.material-library-page .list-item .date {
			display: none;
		}
	}

	.material-library-page .list-col {
		display: flex;
		align-items: center;
		font-size: 14px;
	}

	.material-library-page .list-col.name {
		gap: 12px;
	}

	.material-library-page .material-icon-small {
		font-size: 20px;
	}

	.material-library-page .material-name-small {
		font-weight: 600;
		color: #111827;
		margin-bottom: 2px;
	}

	.material-library-page .material-author {
		font-size: 12px;
		color: #9CA3AF;
	}

	.material-library-page .list-actions {
		display: flex;
		gap: 4px;
	}

	.material-library-page .list-action-btn {
		width: 28px;
		height: 28px;
		border: none;
		border-radius: 6px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		transition: all 0.2s ease;
	}

	.material-library-page .list-action-btn.download {
		background: #2E5CE6;
		color: white;
	}

	.material-library-page .list-action-btn.download:hover {
		background: #1E3A8A;
	}

	.material-library-page .list-action-btn.preview {
		background: #10B981;
		color: white;
	}

	.material-library-page .list-action-btn.preview:hover {
		background: #059669;
	}

	.material-library-page .list-action-btn.edit {
		background: #F59E0B;
		color: white;
	}

	.material-library-page .list-action-btn.edit:hover {
		background: #D97706;
	}

	.material-library-page .list-action-btn.delete {
		background: #EF4444;
		color: white;
	}

	.material-library-page .list-action-btn.delete:hover {
		background: #DC2626;
	}

	/* Empty State */
	.material-library-page .empty-state {
		text-align: center;
		padding: 60px 20px;
	}

	.material-library-page .empty-icon {
		font-size: 64px;
		margin-bottom: 16px;
		opacity: 0.5;
	}

	.material-library-page .empty-title {
		font-size: 20px;
		font-weight: 600;
		color: #111827;
		margin-bottom: 8px;
	}

	.material-library-page .empty-desc {
		font-size: 16px;
		color: #6B7280;
		margin-bottom: 24px;
	}

	/* Buttons */
	.material-library-page .btn {
		padding: 12px 24px;
		border: none;
		border-radius: 12px;
		font-size: 14px;
		font-weight: 600;
		cursor: pointer;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		display: inline-flex;
		align-items: center;
		gap: 8px;
	}

	.material-library-page .btn:hover {
		transform: translateY(-2px);
		box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
	}

	.material-library-page .btn-primary {
		background: linear-gradient(135deg, #2E5CE6 0%, #D97706 100%);
		color: white;
	}

	.material-library-page .btn-secondary {
		background: #F3F4F6;
		color: #111827;
		border: 1px solid #D1D5DB;
	}

	/* Modal Styles */
	.material-library-page .modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1000;
		opacity: 0;
		visibility: hidden;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.material-library-page .modal-overlay.show {
		opacity: 1;
		visibility: visible;
	}

	.material-library-page .modal {
		background: white;
		border-radius: 24px;
		box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
		width: 90%;
		max-width: 600px;
		max-height: 90vh;
		overflow-y: auto;
		transform: translateY(20px);
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.material-library-page .modal-overlay.show .modal {
		transform: translateY(0);
	}

	.material-library-page .modal-header {
		padding: 24px 24px 0 24px;
		border-bottom: 1px solid #E5E7EB;
		margin-bottom: 24px;
	}

	.material-library-page .modal-title {
		font-size: 20px;
		font-weight: 700;
		color: #111827;
		margin-bottom: 8px;
	}

	.material-library-page .modal-subtitle {
		font-size: 14px;
		color: #6B7280;
		margin-bottom: 16px;
	}

	.material-library-page .modal-body {
		padding: 0 24px;
	}

	.material-library-page .modal-footer {
		padding: 24px;
		border-top: 1px solid #E5E7EB;
		display: flex;
		gap: 12px;
		justify-content: flex-end;
	}

	.material-library-page .form-group {
		margin-bottom: 20px;
	}

	.material-library-page .form-label {
		display: block;
		font-size: 14px;
		font-weight: 600;
		margin-bottom: 6px;
		color: #111827;
	}

	.form-el-select {
		width: 100%;
	}

	/deep/.form-el-select .el-input__inner {
		border-radius: 12px;
		padding: 12px 16px;
		border: 2px solid #E5E7EB;
		height: 47px;
	}

	.material-library-page .form-input,
	.material-library-page .form-select,
	.material-library-page .form-textarea {
		width: 100%;
		padding: 12px 16px;
		border: 2px solid #E5E7EB;
		border-radius: 12px;
		font-size: 14px;
		font-family: inherit;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		background: white;
	}

	.material-library-page .form-input:focus,
	.material-library-page .form-select:focus,
	.material-library-page .form-textarea:focus {
		outline: none;
		border-color: #2E5CE6;
		box-shadow: 0 0 0 3px rgba(46, 92, 230, 0.1);
	}

	.material-library-page .form-textarea {
		resize: vertical;
		min-height: 100px;
	}

	.material-library-page .upload-area {
		border: 2px dashed #D1D5DB;
		border-radius: 16px;
		padding: 32px;
		text-align: center;
		background: #F9FAFB;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		cursor: pointer;
		margin-bottom: 16px;
	}

	.material-library-page .upload-area:hover {
		border-color: #2E5CE6;
		background: rgba(46, 92, 230, 0.02);
	}

	.material-library-page .upload-icon {
		font-size: 48px;
		color: #9CA3AF;
		margin-bottom: 16px;
	}

	.material-library-page .upload-text {
		font-size: 16px;
		font-weight: 600;
		color: #111827;
		margin-bottom: 8px;
	}

	.material-library-page .upload-hint {
		font-size: 12px;
		color: #6B7280;
		margin-bottom: 16px;
	}

	.material-library-page .selected-file {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 12px 16px;
		background: #F3F4F6;
		border-radius: 8px;
		margin-top: 12px;
	}

	.material-library-page .file-icon {
		font-size: 20px;
	}

	.material-library-page .file-name {
		font-weight: 500;
		color: #111827;
	}

	.material-library-page .file-size {
		font-size: 12px;
		color: #6B7280;
	}

	.material-library-page .checkbox-group {
		margin-top: 16px;
	}

	.material-library-page .checkbox-item {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-bottom: 8px;
	}

	.material-library-page .checkbox-label {
		font-size: 14px;
		color: #111827;
		cursor: pointer;
	}
</style>